import usePageHistory from '../../hooks/usePageHistory'
import Layout from '../../components/Layout'
import Dashboard from './Dashboard'
import Saisie from './Saisie'
import Recapitulatif from './Recapitulatif'
import RecapAnnuel from './RecapAnnuel'
import TauxOccupation from './TauxOccupation'
import SuiviFinancier from './SuiviFinancier'
import Rapports from './Rapports'
import Reunions from './Reunions'
import Superviseurs from './Superviseurs'
import Tarifs from './Tarifs'
import CampagneDispos from './CampagneDispos'
import CalendrierOuverture from './CalendrierOuverture'
import NouvelleSaison from './NouvelleSaison'
import ConstructeurPlanning from './ConstructeurPlanning'
import AssistanatPlanning from './AssistanatPlanning'

const PAGES = [
  'dashboard', 'saisie', 'recap', 'recap-annuel', 'to', 'financier', 'rapports',
  'reunions', 'superviseurs', 'tarifs', 'planning-annuel', 'assistanat',
  'campagne', 'calendrier', 'nouvelle-saison',
]

export default function CoordinationApp() {
  const [page, setPage] = usePageHistory(PAGES, 'dashboard')
  return (
    <Layout activePage={page} onNavigate={setPage}>
      {page === 'dashboard' && <Dashboard onNavigate={setPage} />}
      {page === 'saisie' && <Saisie />}
      {page === 'recap' && <Recapitulatif />}
      {page === 'recap-annuel' && <RecapAnnuel />}
      {page === 'to' && <TauxOccupation />}
      {page === 'financier' && <SuiviFinancier />}
      {page === 'rapports' && <Rapports />}
      {page === 'reunions' && <Reunions />}
      {page === 'superviseurs' && <Superviseurs />}
      {page === 'tarifs' && <Tarifs />}
      {page === 'planning-annuel' && <ConstructeurPlanning />}
      {page === 'assistanat' && <AssistanatPlanning />}
      {page === 'campagne' && <CampagneDispos />}
      {page === 'calendrier' && <CalendrierOuverture />}
      {page === 'nouvelle-saison' && <NouvelleSaison />}
    </Layout>
  )
}
